import './button.scss';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
const Button = ({
  children,
  onClick,
  isFull,
  type,
  variant,
  size,
  isLoading,
  disabled,
  className,
  ...props
}) => {
  // Merge the caller-supplied className with the variant flags rather
  // than letting `...props` overwrite the .btn base class.
  const btnClass = classNames(
    {
      btn: true,
      'btn--full': isFull,
      [`btn--${variant}`]: variant,
      [`btn--${size}`]: size,
      'btn--disabled': disabled || isLoading
    },
    className
  );
  return (
    <button
      {...props}
      className={btnClass}
      disabled={disabled || isLoading}
      onClick={onClick}
      type={type}
    >
      {children}
      {isLoading && <span className="btn__loader" />}
    </button>
  );
};

Button.propTypes = {
  isFull: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any,
  type: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool
};

export { Button };
